import { client } from "@/api/client";
import interceptors from "@/api/interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProvince(params) {
	return client.get("general/get-province", {
		params: params,
	});
}

function getOptionProvince(params) {
	return client.get("general/get-province-option", {
		params: params,
	});
}

function getCity(params) {
	return client.get("general/get-city", {
		params: params,
	});
}

function getOptionCity(params) {
	return client.get("general/get-city-option", {
		params: params,
	});
}

// function getOptionCityProvince(params) {
// 	return client.get("general/get-city-province-option", {
// 		params: params,
// 	});
// }

function getBank(params) {
	return client.get("general/get-bank", {
		params: params,
	});
}

// function getOptionBank(params) {
// 	return client.get("general/get-bank-option", {
// 		params: params,
// 	});
// }

function getOptionDownline(params) {
	return client.get("binary/network/downline", {
		params: params,
	});
}

export default {
	getProvince,
	getOptionProvince,
	getCity,
	getOptionCity,
	// getOptionCityProvince,
	// getOptionBank,
	getBank,
	getOptionDownline
};